import {
  GET_LIST_NASABAH_BRI,
  LOADING_GET_LIST_NASABAH_BRI,
  GET_LIST_NASABAH_NON_BRI,
  LOADING_GET_LIST_NASABAH_NON_BRI,
  GET_LIST_NASABAH_DITINDAKLANJUTI,
  LOADING_GET_LIST_NASABAH_DITINDAKLANJUTI,
  GET_ONBOARDING,
  LOADING_GET_ONBOARDING,
  GET_DETAIL_NASABAH_BRI,
  LOADING_GET_DETAIL_NASABAH_BRI,
  GET_DETAIL_NASABAH_DITINDAKLANJUTI,
  LOADING_GET_DETAIL_NASABAH_DITINDAKLANJUTI,
  GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI,
  LOADING_GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI,
  GET_LIST_ALASAN_TIDAK_COCOK,
  LOADING_GET_LIST_ALASAN_TIDAK_COCOK,
  GET_INFORMASI_TIER_NASABAH,
  LOADING_GET_INFORMASI_TIER_NASABAH,
  SUBMIT_TINDAKLANJUT_POSITIF_CASE_1,
  SUBMIT_TINDAKLANJUT_POSITIF_CASE_2,
  SUBMIT_TINDAKLANJUT_NEGATIF_CASE_1,
  SUBMIT_TINDAKLANJUT_NEGATIF_CASE_2,
  SUBMIT_TINDAKLANJUT_NEGATIF_CASE_3,
  SUBMIT_TINDAKLANJUT_OTHER_CASE,
  LOADING_SUBMIT_TINDAKLANJUT,
  INFINITE_SCROLL_NASABAH_BRI,
  INFINITE_SCROLL_NASABAH_NON_BRI,
  INFINITE_SCROLL_NASABAH_DITINDAKLANJUTI,
  LOADING_INFINITE_SCROLL
} from '../constants/link5';

const initialState = {
  listNasabahBRI: { data: [] },
  isLoadingListNasabahBRI: false,

  listNasabahNonBRI: { data: [] },
  isLoadingListNasabahNonBRI: false,

  listNasabahDitindaklanjuti: { data: [] },
  isLoadingListNasabahDitindaklanjuti: false,

  isLoadingInfiniteScroll: false,

  detailNasabahBRI: [],
  detailNasabahDitindaklanjuti: [],
  isLoadingDetail: false,

  listAlasanTidakDapatDihubungi: [],
  isLoadingListAlasanTidakDapatDihubungi: false,

  listAlasanTidakCocok: [],
  isLoadingListAlasanTidakCocok: false,

  DeskripsiOnboard: [],
  isLoadingDeskripsiOnboard: false,

  informasiTier: [],
  isLoadingInformasiTier: false,

  SubmitPositifCase1: [],
  SubmitPositifCase2: [],
  SubmitNegatifCase1: [],
  SubmitNegatifCase2: [],
  SubmitNegatifCase3: [],
  SubmitOtherCase: [],
  isLoadingSubmitTindakLanjut: false
};

export default function reducer(
  state = initialState,
  action = { type: '', payload: [] }
) {
  const { type, payload } = action;
  switch (type) {
    // list nasabah bri
    case GET_LIST_NASABAH_BRI:
      return {
        ...state,
        listNasabahBRI: payload,
        isLoadingListNasabahBRI: false,
      };
    case LOADING_GET_LIST_NASABAH_BRI:
      return {
        ...state,
        isLoadingListNasabahBRI: true,
      };

    // list nasabah non bri
    case GET_LIST_NASABAH_NON_BRI:
      return {
        ...state,
        listNasabahNonBRI: payload,
        isLoadingListNasabahNonBRI: false,
      };
    case LOADING_GET_LIST_NASABAH_NON_BRI:
      return {
        ...state,
        isLoadingListNasabahNonBRI: true,
      };

    // list nasabah ditindaklanjuti
    case GET_LIST_NASABAH_DITINDAKLANJUTI:
      return {
        ...state,
        listNasabahDitindaklanjuti: payload,
        isLoadingListNasabahDitindaklanjuti: false,
      };
    case LOADING_GET_LIST_NASABAH_DITINDAKLANJUTI:
      return {
        ...state,
        isLoadingListNasabahDitindaklanjuti: true,
      };

    // detail nasabah bri
    case GET_DETAIL_NASABAH_BRI:
      return {
        ...state,
        detailNasabahBRI: payload,
        isLoadingDetail: false,
      };
    case LOADING_GET_DETAIL_NASABAH_BRI:
      return {
        ...state,
        isLoadingDetail: true,
      };

    // detail nasabah ditindaklanjuti
    case GET_DETAIL_NASABAH_DITINDAKLANJUTI:
      return {
        ...state,
        detailNasabahDitindaklanjuti: payload,
        isLoadingDetail: false,
      };
    case LOADING_GET_DETAIL_NASABAH_DITINDAKLANJUTI:
      return {
        ...state,
        isLoadingDetail: true,
      };

    // onboarding
    case GET_ONBOARDING:
      return {
        ...state,
        DeskripsiOnboard: payload,
        isLoadingDeskripsiOnboard: false,
      };
    case LOADING_GET_ONBOARDING:
      return {
        ...state,
        isLoadingDeskripsiOnboard: true,
      };

    // list alasan tidak dapat dihubungi
    case GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI:
      return {
        ...state,
        listAlasanTidakDapatDihubungi: payload,
        isLoadingListAlasanTidakDapatDihubungi: false,
      };
    case LOADING_GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI:
      return {
        ...state,
        isLoadingListAlasanTidakDapatDihubungi: true,
      };

    // list alasan tidak cocok
    case GET_LIST_ALASAN_TIDAK_COCOK:
      return {
        ...state,
        listAlasanTidakCocok: payload,
        isLoadingListAlasanTidakCocok: false,
      };
    case LOADING_GET_LIST_ALASAN_TIDAK_COCOK:
      return {
        ...state,
        isLoadingListAlasanTidakCocok: true,
      };

    // informasi tier nasabah_bri
    case GET_INFORMASI_TIER_NASABAH:
      return {
        ...state,
        informasiTier: payload,
        isLoadingInformasiTier: false,
      };
    case LOADING_GET_INFORMASI_TIER_NASABAH:
      return {
        ...state,
        isLoadingInformasiTier: true,
      };

    // infinite scroll nasabah bri
    case INFINITE_SCROLL_NASABAH_BRI:
      return {
        ...state,
        listNasabahBRI: {
          ...state.listNasabahBRI,
          data: [ ...state.listNasabahBRI.data, ...payload]
        },
        isLoadingInfiniteScroll: false,
      };

    // infinite scroll nasabah non bri
    case INFINITE_SCROLL_NASABAH_NON_BRI:
      return {
        ...state,
        listNasabahNonBRI: {
          ...state.listNasabahNonBRI,
          data: [...state.listNasabahNonBRI.data, ...payload],
        },
        isLoadingInfiniteScroll: false,
      };

    // infinite scroll nasabah ditindaklanjuti
    case INFINITE_SCROLL_NASABAH_DITINDAKLANJUTI:
      return {
        ...state,
        listNasabahDitindaklanjuti: {
          ...state.listNasabahDitindaklanjuti,
          data: [...state.listNasabahDitindaklanjuti.data, ...payload],
        },
        isLoadingInfiniteScroll: false,
      };

    case LOADING_INFINITE_SCROLL:
      return {
        ...state,
        isLoadingInfiniteScroll: true,
      };

    // Submit Tindak Lanjut
    case SUBMIT_TINDAKLANJUT_POSITIF_CASE_1:
      return {
        ...state,
        SubmitPositifCase1: payload,
        isLoadingSubmitTindakLanjut: false,
      };
    case SUBMIT_TINDAKLANJUT_POSITIF_CASE_2:
      return {
        ...state,
        SubmitPositifCase2: payload,
        isLoadingSubmitTindakLanjut: false,
      };
    case SUBMIT_TINDAKLANJUT_NEGATIF_CASE_1:
      return {
        ...state,
        SubmitNegatifCase1: payload,
        isLoadingSubmitTindakLanjut: false,
      };
    case SUBMIT_TINDAKLANJUT_NEGATIF_CASE_2:
      return {
        ...state,
        SubmitNegatifCase2: payload,
        isLoadingSubmitTindakLanjut: false,
      };
    case SUBMIT_TINDAKLANJUT_NEGATIF_CASE_3:
      return {
        ...state,
        SubmitNegatifCase3: payload,
        isLoadingSubmitTindakLanjut: false,
      };
    case SUBMIT_TINDAKLANJUT_OTHER_CASE:
      return {
        ...state,
        SubmitOtherCase: payload,
        isLoadingSubmitTindakLanjut: false,
      };
    case LOADING_SUBMIT_TINDAKLANJUT:
      return {
        ...state,
        isLoadingSubmitTindakLanjut: true,
      };

    default:
      return state;
  }
}
